import React, { useRef, useState, useEffect } from "react";
import { Message } from "@/entities/message";
import { formatDate } from "@/shared/lib";
import { Check, CheckAll } from "react-bootstrap-icons";
import { useAuthStore } from "@/features/auth";
import { smartTruncateAroundQuery } from "../../lib";

export interface MessageItemProps {
  message: Message;
  query: string;
  onSelectMessage: (chatId: string, messageId: string) => void;
}

export const MessageItem: React.FC<MessageItemProps> = ({
  message,
  query,
  onSelectMessage,
}) => {
  const userId = useAuthStore((state) => state.user?._id);
  const textRef = useRef<HTMLDivElement>(null);
  const [containerWidth, setContainerWidth] = useState<number | null>(null);

  useEffect(() => {
    if (textRef.current) {
      const width = textRef.current.offsetWidth;
      if (width > 0) {
        setContainerWidth(width);
      }
    }
  }, [query, message.text]);

  const getContactName = (msg: any) => {
    const currentUser = useAuthStore.getState().user;
    if (msg.owner === currentUser?._id) {
      return currentUser?.firstName;
    }
    return msg.chat?.contact?.firstName || "Неизвестный";
  };

  return (
    <div
      key={message._id}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onSelectMessage(message.chat._id, message._id);
      }}
      className="p-2 d-flex align-items-center gap-2"
      style={{
        cursor: "pointer",
        transition: "background-color 0.2s ease",
        backgroundColor: "transparent",
        width: "100%",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = "#f8f9fa";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = "transparent";
      }}
    >
      <div
        className="rounded-circle bg-secondary text-white d-flex justify-content-center align-items-center"
        style={{
          position: "relative",
          width: 38,
          minWidth: 38,
          height: 38,
          fontSize: 21,
        }}
      >
        {message.chat?.contact?.user?.firstName?.[0]?.toUpperCase() || "?"}
        {message.chat?.contact?.user?.isOnline && (
          <div
            className="position-absolute rounded-circle border border-white"
            style={{
              width: 10,
              height: 10,
              bottom: 0,
              right: 0,
              backgroundColor: "#12ea12",
            }}
          />
        )}
      </div>

      <div
        className="d-flex flex-column flex-grow-1 min-w-0"
        style={{
          overflow: "hidden",
        }}
      >
        <div className="d-flex justify-content-between align-items-start">
          <div
            className="d-flex flex-column"
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              width: "100%",
            }}
          >
            <div
              className="fw-bold"
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {getContactName(message)}
            </div>

            <span
              ref={textRef}
              className="d-inline-block"
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "100%",
              }}
            >
              {containerWidth
                ? smartTruncateAroundQuery(message.text, query, containerWidth)
                : message.text}
            </span>
          </div>

          <div
            className="d-flex flex-column align-items-end"
            style={{
              flexShrink: 0,
              marginLeft: "8px",
            }}
          >
            <small className="text-muted mb-1">
              {formatDate(new Date(message.createdAt).getTime())}
            </small>
            <div>
              {message.owner._id === userId && (
                <>
                  {!message.delivedAt && !message.readedAt && !message.err && (
                    <Check size={12} color="#6c757d" />
                  )}
                  {message.delivedAt && !message.readedAt && (
                    <CheckAll size={12} color="#6c757d" />
                  )}
                  {message.readedAt && (
                    <CheckAll size={12} color="#007bff" />
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};